"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Percentage = createSVGIcon(
  <>
    <circle cx="6" cy="7.5" r="2.625" stroke="currentColor" strokeWidth="1.5" />
    <circle
      cx="17.25"
      cy="17.25"
      r="2.625"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      stroke="currentColor"
      strokeWidth="1.5"
      d="M3.704 20.204 18.704 5.205"
    />
  </>,
  "Percentage",
  { viewBox: "0 0 24 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
